export default __webpack_public_path__ + "static/media/yachts.eaec25c8.svg";